import React from "react";

class Langbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value || this.props.placeholder,
    };
  }

  removeLangbox() {
    this.props.removeLangbox(this.props.type);
  }
  componentDidMount() {
    let field = null;
    if (
      (field = document
        .querySelector("#box_text_langboxes_" + this.props.type + "-" + lang)
        .querySelector(this.props.type)) !== null
    ) {
      field.setAttribute("placeholder", this.state.value);
    }
  }
  htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }
  render() {
    var self = this;
    return (
      <div className="rental-unit-langbox-edit">
        <div className="languageBox relative mb-1">
          <div className="content">
            {available_languages.map((thisLocale, thisIndex) => (
              <div
                key={thisIndex}
                id={"box_text_langboxes_" + this.props.type + "-" + thisLocale}
                className={
                  (thisLocale == lang ? "active" : "") +
                  " mdc-text-field--no-label"
                }
              >
                {this.props.placeholder != ""
                  ? ""
                  : htmlToDom(this.props.langbox.prototype.label)}
                {this.props.type == "descriptions" ? (
                  <textarea
                    id={"descriptions" + this.props.unitIndex + thisLocale}
                    className="mdc-text-field__input mdc-text-field__textarea"
                    name={
                      "rental[units][" +
                      this.props.unitIndex +
                      "][descriptions][" +
                      thisLocale +
                      "]"
                    }
                    maxLength="500"
                    cols="3"
                    defaultValue={
                      this.props.langbox.value !== undefined
                        ? this.htmlDecode(
                            this.props.langbox.value[thisLocale] || ""
                          )
                        : ""
                    }
                  ></textarea>
                ) : (
                  <input
                    id={"taglines_" + this.props.unitIndex + thisLocale}
                    className="mdc-text-field__input"
                    name={
                      "rental[units][" +
                      this.props.unitIndex +
                      "][taglines][" +
                      thisLocale +
                      "]"
                    }
                    maxLength="60"
                    defaultValue={
                      this.props.langbox.value !== undefined
                        ? this.htmlDecode(
                            this.props.langbox.value[thisLocale] || ""
                          )
                        : ""
                    }
                  />
                )}
              </div>
            ))}
          </div>
          <ul className="nav bottom">
            {available_languages.map((thisLocale, thisIndex) => (
              <li
                key={thisIndex}
                data-ref={
                  "#box_text_langboxes_" + this.props.type + "-" + thisLocale
                }
                className={thisLocale == lang ? "active" : ""}
              >
                <span className="label">
                  <svg className="black circle shadow" width="20" height="20">
                    <use href={"#flag-" + thisLocale}></use>
                  </svg>
                  {/* <i className={"flag flag-" + thisLocale}></i> */}
                  <span className="ms-1 ib">
                    {window.Translator.trans(
                      "locale.languages." + thisLocale,
                      {},
                      "js"
                    )}
                  </span>
                </span>
              </li>
            ))}
            <li
              className="pr btn small p-0"
              onClick={() => {
                this.removeLangbox();
              }}
            >
              <span className="">
                <svg className="icon no" width="12" height="12">
                  <use href="#no"></use>
                </svg>
                <span>
                  {window.Translator.trans("units.buttons.remove", {}, "js")}
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Langbox;
